<div class="folder-back-container" [@backButton]="backIsEnabled">
    <div class="back-icon"
         (click)="onFolderBack.emit()">
      <mat-icon>arrow_back</mat-icon>
    </div>
</div>
<div class="folder-info-container">
    <div class="folder-path overflow-hidden">
      <mat-icon class="folder-icon">folder</mat-icon>
      <div class="folder-path-ellipsis overflow-hidden" *ngIf="path.length > 1">
        <ng-container *ngFor="let pathFolder of path">
          <span *ngIf="pathFolder.payload.id">></span>
          <span class="text-ellipsis"
                [matTooltip]="pathFolder.name$ | async"
                *ngIf="pathFolder !== folder">
            <a (click)="onFolderSelect.emit(pathFolder)">{{ pathFolder.name$ | async }}</a>
          </span>
        </ng-container>
      </div>
      <span>{{ folder.name$ | async }}</span>
      <mat-icon class="material-icons-outlined color-grey-light color-black-hover icon-info"
                customToolTip
                [contentTemplate]="tooltip"
                *ngIf="showHelpText && ((folder.reportCount$ | async) || (folder.folderCount$ | async))">info</mat-icon>
      <ng-template #tooltip>
        <app-folder-selector-dialog-folder-tooltip [folder]="folder"></app-folder-selector-dialog-folder-tooltip>
      </ng-template>
</div>
<div class="folder-info">{{ folder.totalFolderCount$ | async }} {{ 'folder_selector.folders' | translate }}, {{ folder.totalReportCount$ | async }} {{ 'folder_selector.reports' | translate }}</div>
</div>
<div class="folder-actions-container">
    <ng-content></ng-content>
</div>

